import { render } from "./customers-refund.vue?vue&type=template&id=0034e19c"
import script from "./customers-refund.vue?vue&type=script&lang=js"
export * from "./customers-refund.vue?vue&type=script&lang=js"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__